var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.151,
    height: 49.976,
    viewBox: "0 0 47.151 49.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_157",
    "data-name": "Raggruppa 157",
    transform: "translate(1.287 1.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_170",
    "data-name": "Tracciato 170",
    d: "M24.344,31.2,33.462,6.178a.3.3,0,0,0-.179-.388L17.355,0,9.639,3.582.019,30.017A.3.3,0,0,0,.2,30.4L19.485,37.42l2.28.834S23.65,33.1,24.344,31.2Z",
    transform: "translate(0 11.451) rotate(-20)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_170",
    "data-name": "Linea 170",
    x2: 15.691,
    y2: 5.712,
    transform: "translate(13.569 25.051) rotate(-20)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_171",
    "data-name": "Linea 171",
    x2: 15.691,
    y2: 5.712,
    transform: "translate(13.569 28.88) rotate(-20)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_172",
    "data-name": "Linea 172",
    x2: 15.691,
    y2: 5.709,
    transform: "translate(13.57 32.71) rotate(-20)",
    fill: "none",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_171",
    "data-name": "Tracciato 171",
    d: "M7.715,0,0,3.6,5.657,5.657Z",
    transform: "translate(9.058 8.154) rotate(-20)",
    fill: "#e02027",
    stroke: "#272829",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_996",
    "data-name": "Tracciato 996",
    d: "M3.292,4.941H3.058q-.116,0-.221-.007V6.681H2.029V2.051l.242-.014q.136-.007.288-.01l.306-.008h.285a2.536,2.536,0,0,1,.716.1,1.559,1.559,0,0,1,.554.284,1.28,1.28,0,0,1,.358.468,1.534,1.534,0,0,1,.126.642,1.553,1.553,0,0,1-.1.554,1.277,1.277,0,0,1-.295.456,1.4,1.4,0,0,1-.5.312A2,2,0,0,1,3.292,4.941ZM3.254,2.689H3.039q-.105,0-.2.007V4.261q.1.007.207.007h.228a.737.737,0,0,0,.572-.21.873.873,0,0,0,.19-.61A.837.837,0,0,0,3.861,2.9.747.747,0,0,0,3.254,2.689Zm2.495-.638q.091-.007.288-.014t.414-.01l.418-.007H7.18A3.742,3.742,0,0,1,8.3,2.16a2.081,2.081,0,0,1,.726.386,1.845,1.845,0,0,1,.543.817,3.423,3.423,0,0,1,.168,1.1,3.254,3.254,0,0,1-.116.874,1.723,1.723,0,0,1-.414.733,2.052,2.052,0,0,1-.821.5,4.054,4.054,0,0,1-1.333.187q-.295,0-.631-.021t-.667-.057Zm1.5,4.041a1.648,1.648,0,0,0,1.238-.407,1.876,1.876,0,0,0,.39-1.325A2.919,2.919,0,0,0,8.8,3.634a1.185,1.185,0,0,0-.277-.522A1.2,1.2,0,0,0,8,2.8a2.736,2.736,0,0,0-.821-.105H6.909q-.164,0-.348.007V6.066q.2.014.379.021T7.25,6.092Zm5.6-1.515H11.523v2.1h-.808V2.051H13.36v.7H11.522V3.875h1.325Z",
    transform: "translate(14.578 14.44)",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPdfIcon);
export default __webpack_public_path__ + "static/media/action-pdf-icon.46b9547f653d153401ee355ca9350cce.svg";
export { ForwardRef as ReactComponent };